module.exports = __webpack_public_path__ + "img/attrs.7551bbc3.png";